import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { Eureka_SearchRequest_SearchResultOption, useUpdateEurekaCompletionsMutation, } from '../../services/generated/graphql-types';
import { COMPLETE_INFO, DEBOUNCE_DURATION, mapObjectCompletions, mapQueryCompletions, MAX_COMPLETIONS, tokenizeQuery, } from './spotlight-completions.util';
export { EurekaObjectType, EurekaQueryCompletionType, } from './spotlight-completions.util';
const EMPTY_COMPLETIONS = {
    objectCompletions: [],
    queryCompletions: [],
};
export const useSpotlightEurekaCompletions = (query, enabled = true) => {
    const [{ objectCompletions, queryCompletions }, setCompletions] = useState(EMPTY_COMPLETIONS);
    const [loading, setLoading] = useState(false);
    const [mutateFn] = useUpdateEurekaCompletionsMutation();
    const mutateFnRef = useRef(mutateFn);
    mutateFnRef.current = mutateFn;
    const enabledRef = useRef(enabled);
    enabledRef.current = enabled;
    const inFlightRequestAbortController = useRef(null);
    const debouncedMutation = useRef(_.debounce(async (searchQuery) => {
        if (!enabledRef.current)
            return;
        if (inFlightRequestAbortController.current) {
            inFlightRequestAbortController.current.abort();
        }
        const controller = new AbortController();
        inFlightRequestAbortController.current = controller;
        const tokens = tokenizeQuery(searchQuery);
        const cursorTokenIdx = Math.max(tokens.length - 1, 0);
        try {
            setLoading(true);
            const result = await mutateFnRef.current({
                variables: {
                    params: {
                        completeInfo: COMPLETE_INFO,
                        filterSelections: [],
                        maxCompletions: MAX_COMPLETIONS,
                        searchOption: Eureka_SearchRequest_SearchResultOption.SearchResults,
                        tokens,
                        cursorTokenIdx,
                    },
                },
                context: {
                    fetchOptions: { signal: controller.signal },
                },
            });
            const data = result.data?.mutationComplete;
            setCompletions({
                objectCompletions: mapObjectCompletions(data?.result || []),
                queryCompletions: mapQueryCompletions(data?.queryResult || []),
            });
        }
        catch {
        }
        finally {
            if (inFlightRequestAbortController.current === controller) {
                setLoading(false);
            }
        }
    }, DEBOUNCE_DURATION)).current;
    useEffect(() => {
        if (!enabled || !query.trim()) {
            setCompletions(EMPTY_COMPLETIONS);
        }
        else {
            debouncedMutation(query);
        }
        return () => debouncedMutation.cancel();
    }, [query, enabled, debouncedMutation]);
    return { objectCompletions, queryCompletions, loading };
};
//# sourceMappingURL=use-spotlight-completions.js.map